import { Auth } from '@/auth/Auth'
import { Configuration, DefaultApi } from '@flatfile/api'

export const HTTPService = new DefaultApi(
  new Configuration({
    accessToken: () => Auth.TOKEN ?? '',
    basePath: import.meta.env.VITE_BASE_API_URL ?? 'http://localhost:3000/v1',
  })
)
